/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { memo } from "react";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import Loan from "./Loan";
// import PaymentMethod from "./PaymentMethod";
import { LoanDetails } from "../../../../helpers/FormDetails/ProposalDetails/interfaces";
import PlanDetails from "./PlanDetails";
import PremiumDetails from "./PremiumDetails";
import PremiumFunding from "./PremiumFunding";

interface Props {
  formik: FormikProps<LoanDetails>;
}
function LoanForm({ formik }: Props) {
  const recalculateError = useAppSelector((state) => state.common?.recalculateError);
  return (
    <>
      <Loan formik={formik} />
      <PlanDetails formik={formik} />
      <PremiumDetails formik={formik} />
      {/* <PaymentMethod formik={formik} /> */}
      <PremiumFunding formik={formik} />
      {recalculateError && <div className="font-bold mt-7 text-hotShot">{recalculateError}</div>}
    </>
  );
}

export default memo(LoanForm);
